// Example 'CUSTOM_ERROR=1010?quoteno=80980987&info2=324=2'
// TODO: Decompose and refactor.
const HEADER = 'CUSTOM_ERROR'
export type CustomErrorCodeName = 'processing_quote';
export const ERROR_PROCESSING_QUOTE_CODE = '1010'
// eslint-disable-next-line no-unused-vars
export const ERROR_CODES: { [key in CustomErrorCodeName]: string } = {
  processing_quote: ERROR_PROCESSING_QUOTE_CODE
}

export const isErrorCodeExist = (code: string) => Object.values(ERROR_CODES).includes(code)
const errorInfoKeys: { [key: string]: string[] } = {
  [ERROR_PROCESSING_QUOTE_CODE]: ['quoteno']
}
export const parseCustomError = (message: string) => {
  if (typeof message !== 'string') return null
  const CODE_LENGTH = 4
  const isCustomMessage = HEADER === message.substring(0, HEADER.length)
  if (isCustomMessage) {
    try {
      const startOfCode = HEADER.length + 1
      const code = message.substring(startOfCode, startOfCode + CODE_LENGTH)
      if (!isErrorCodeExist(code)) return null
      const info = Object.fromEntries(
        message
          .substring(startOfCode + CODE_LENGTH + 1, message.length)
          .split('&')
          .map((infoEl: string) => [
            infoEl.slice(0, infoEl.indexOf('=')),
            infoEl.slice(infoEl.indexOf('=') + 1)
          ])
      )
      return {
        code,
        info
      }
    } catch (err) {
      console.warn(err)
      return null
    }
  }
  return null
}

export const createCustomError = (code: string, info: { [key: string]: string }): string | null => {
  if (!isErrorCodeExist(code)) return null
  let error = HEADER + '=' + code
  errorInfoKeys[code].forEach((key: string, index) => {
    const value = info[key]
    if (index === 0) error += `?${key}=${value}`
    else error += `&${key}=${value}`
  })
  return error
}
